import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ContentsLiveCamera',
  components: {
    FileSelectorButton
  },
  data () {
    return {
      // input
      input: {
        liveCameraUseFlg: 0,
        liveCameraSettings: []
      },

      cameraCount: 10,
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
    }),

    // list
    liveCameraUseList () {
      return Constants.ServiceContents.LiveCameraUse.sort(Utility.sortByKey('index', true))
    },

    // validate
    formIsValid () {
      return this.validate('liveCameraUseFlg')
    },

    // jsonb
    getJsonb () {
      let jsonb = {
        liveCameraUseFlg: this.input.liveCameraUseFlg
      }

      // ライブカメラ利用
      if (jsonb.liveCameraUseFlg === 1) {
        jsonb.liveCameraSettings = []
        for (let i = 0; i < this.cameraCount; i++) {
          if (Validator.validText(this.input.liveCameraSettings[i].caption) &&
            Validator.validText(this.input.liveCameraSettings[i].accessUrl)) {
            jsonb.liveCameraSettings.push(this.input.liveCameraSettings[i])
          }
        }
      }
      
      return jsonb
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'contentsLiveCamera',
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      setValidate: 'serviceContentsSettingForm/setValidate'
    }),

    init () {
      for (let i = 0; i < this.cameraCount; i++) {
        this.input.liveCameraSettings.push({
          caption: null,
          accessUrl: null
        })
      }

      if (this.values.contentsLiveCamera) {
        let data = $.extend(true, this.input, this.values.contentsLiveCamera)
        this.$set(this, 'input', data)
      }

      // 必須項目なし、もしくはラジオボタンのみの場合
      this.setValidate({
        key: 'contentsLiveCamera',
        value: true
      })
    },

    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      this.$set(this.input, props.name, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', this.input[props.name])
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      this.$set(this.input, props.name, null)
      console.log('deleteFileFromSelector', null)
    },

    validate (key) {
      switch (key) {
        case 'liveCameraUseFlg':
          return Validator.validRadio(this.input[key])
      }
    },
  }
}
